import { render, staticRenderFns } from "./leaveMessageDialog.vue?vue&type=template&id=0f2ddda2"
import script from "./leaveMessageDialog.vue?vue&type=script&lang=js"
export * from "./leaveMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./leaveMessageDialog.vue?vue&type=style&index=0&id=0f2ddda2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports